// Get Regularusers UserGroups
export const GET_REGULARUSERS_GROUPS_REQUEST = 'GET_REGULARUSERS_GROUPS_REQUEST';
export const GET_REGULARUSERS_GROUPS_DONE = 'GET_REGULARUSERS_GROUPS_DONE';
export const GET_REGULARUSERS_GROUPS_FAILED = 'GET_REGULARUSERS_GROUPS_FAILED';

// Operations
export const REGULARUSERS_GROUPS_SET_PAGE = 'REGULARUSERS_GROUPS_SET_PAGE';